import EmptyFilter from './EmptyFilter'
import FilterFactory from './FilterFactory'
import IFilter from './IFilter'
import OperatorFilter from './OperatorFilter'
import RangeFilter from './RangeFilter'
import TermFilter from './TermFilter'
import ExistFilter from './ExistFilter'
import TypeFilter from './TypeFilter'
import InFilter from './InFilter'
import AdvanceTermFilter from "./AdvanceTermFilter";
import ObjectIdFactory from "./ObjectIdFactory";
import ObjectID from 'bson-objectid';

export * as helpers from './helpers'

//setting Factory
const OPERATORS = ['AND', 'OR', 'NOR', 'NOT']
const ADVANCE_OPERATORS = ['NE', 'NIN', 'TERMS']

const TYPES = {
  'TERM': TermFilter,
  'RANGE': RangeFilter,
  'IN': InFilter,
  'EMPTY': EmptyFilter,
  'TYPE': TypeFilter,
  'EXISTS': ExistFilter,
}

OPERATORS.forEach(op => {
  TYPES[op] = OperatorFilter
})

ADVANCE_OPERATORS.forEach(op => {
  TYPES[op] = AdvanceTermFilter
})

FilterFactory.setup(TYPES)
ObjectIdFactory.setup(ObjectID)

export {
  IFilter,
  TYPES,
  EmptyFilter,
  FilterFactory,
  OperatorFilter,
  RangeFilter,
  TermFilter,
  ExistFilter,
  InFilter,
  AdvanceTermFilter,
  ObjectIdFactory
}
